module.exports = __webpack_public_path__ + "img/ks-4-Types-Of-Saving-Concept-pdf.fb805be0.jpeg";